import { useMemo, useState } from "react";
import { Calendar as BigCalendar, dateFnsLocalizer } from "react-big-calendar";
import format from "date-fns/format";
import parse from "date-fns/parse";
import startOfWeek from "date-fns/startOfWeek";
import getDay from "date-fns/getDay";
import enUS from "date-fns/locale/en-US";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "./task-calendar.css";

const locales = { "en-US": enUS };
const localizer = dateFnsLocalizer({ format, parse, startOfWeek, getDay, locales });

const PRIORITY_HUE = {
  urgent: "hsl(0 84% 60%)",
  high: "hsl(38 92% 50%)",
  medium: "hsl(224 87% 55%)",
  low: "hsl(220 15% 50%)",
};

/**
 * Task calendar built on react-big-calendar. Tasks with a due_date become
 * all-day events on that date; onSelectTask fires when a user clicks one.
 */
export default function TaskCalendar({ tasks = [], onSelectTask }) {
  const [view, setView] = useState("month");
  const [date, setDate] = useState(new Date());

  const events = useMemo(
    () =>
      tasks
        .filter((t) => t.due_date)
        .map((t) => ({
          id: t.id,
          title: t.title,
          start: new Date(t.due_date),
          end: new Date(t.due_date),
          allDay: true,
          resource: t,
        })),
    [tasks],
  );

  const eventPropGetter = (event) => {
    const t = event.resource || {};
    const done = t.task_status === "done";
    return {
      style: {
        backgroundColor: done ? "hsl(158 64% 42% / 0.9)" : PRIORITY_HUE[t.priority] || PRIORITY_HUE.medium,
        color: "#fff",
        border: 0,
        borderRadius: "6px",
        padding: "2px 6px",
        fontSize: "12px",
        fontWeight: 500,
        opacity: done ? 0.55 : 1,
        textDecoration: done ? "line-through" : "none",
      },
    };
  };

  return (
    <div className="border border-border rounded-md bg-card p-3" style={{ height: "calc(100vh - 220px)", minHeight: 500 }} data-testid="tasks-calendar">
      <BigCalendar
        localizer={localizer}
        events={events}
        view={view}
        views={["month", "week", "day", "agenda"]}
        onView={setView}
        date={date}
        onNavigate={setDate}
        onSelectEvent={(evt) => onSelectTask?.(evt.resource)}
        eventPropGetter={eventPropGetter}
        popup
        style={{ height: "100%" }}
      />
    </div>
  );
}
